<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e56NaN">
</p><p class="bkt" id="d7e91"><b>Nightmare in Niceville </b></p>
<p class="txc" id="d7e141"><big><big><b>by<br/>Amberle Cianne </b></big></big></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cian_9781937084424_epub_c2_r1.vue?543fb5f5